module.exports = __webpack_public_path__ + "static/media/task_unchecked.9b2d8461.svg";